/**
 * /advertisers/portal — advertiser portal landing (OPUS DASH-12).
 *
 * Declares the TanStack Router route and delegates rendering to
 * `AdvertiserPortalPage`. The flat-file naming convention uses dots as path
 * separators, so `advertisers.portal.tsx` maps to `/advertisers/portal`.
 *
 * Follows the same shape as `campaigns.os-targeting.tsx` (the opX feature
 * route that landed on staging-main) so future wire-up cycles can mount it
 * by importing this module.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserPortalPage } from "@/features/advertiser-portal/AdvertiserPortalPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/advertisers/portal`. No search params yet; keep the
// `validateSearch` hook reserved so future drilldowns (e.g. filter by
// advertiser id) can extend without touching the shared router.
// ---------------------------------------------------------------------------

interface AdvertiserPortalSearch {
	advertiserId?: string;
}

export const advertisersPortalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/portal",
	validateSearch: (raw: Record<string, unknown>): AdvertiserPortalSearch => {
		const advertiserId = raw.advertiserId;
		if (typeof advertiserId === "string" && advertiserId.trim().length > 0) {
			return { advertiserId: advertiserId.trim() };
		}
		return {};
	},
	component: AdvertiserPortalPage,
});

export default advertisersPortalRoute;

// Re-export the page so the router can `import { AdvertiserPortalPage }`
// from this module if the central wire-up prefers a single-source import.
export { AdvertiserPortalPage } from "@/features/advertiser-portal/AdvertiserPortalPage";
